import { render, staticRenderFns } from "./honor-detail-modal.vue?vue&type=template&id=d3799788&scoped=true"
import script from "./honor-detail-modal.vue?vue&type=script&lang=js"
export * from "./honor-detail-modal.vue?vue&type=script&lang=js"
import style0 from "./honor-detail-modal.vue?vue&type=style&index=0&id=d3799788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3799788",
  null
  
)

export default component.exports